$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500,
      href = $(this).attr('href'),
      target = $(href == '#' || href == '' ? 'html' : href),
      position = target.offset().top;

    // ヘッダーの高さを取得
    var headerHeight = $('.site-header').outerHeight(); // 例: .header はヘッダーのクラス名

    // スクロール位置からヘッダーの高さを引く
    position -= headerHeight;

    // fadeクラスが存在し、is-fadeクラスが存在しない場合はさらに50pxをオフセットとして使う
    if ($('.fade').length && !$('.is-fade').length) {
      position -= 50;
    }

    return $('html, body').animate({ scrollTop: position }, speed, 'swing'), !1;
  });
});

$(function () {
  $('.wsc-h-fix').each(function (index, el) {
    var hFix = $(this),
      about = $('.wsc-about'),
      isFix = !1,
      timer;
    run(),
      $(window).on('scroll', function (event) {
        run();
      });
    function run() {
      var wT = $(window).scrollTop(),
        wC = wT,
        aboutT = about.offset().top - 150;
      wC > aboutT
        ? isFix ||
          ((isFix = !0),
          hFix.addClass('is-fix'),
          clearTimeout(timer),
          (timer = setTimeout(function () {
            hFix.addClass('is-show');
          }, 300)))
        : isFix &&
          ((isFix = !1),
          hFix.removeClass('is-show'),
          clearTimeout(timer),
          (timer = setTimeout(function () {
            hFix.removeClass('is-fix');
          }, 300)));
    }
  });
});
$(function () {
  $('.wsc-kv-slider').each(function (index, el) {
    var slider = $(this),
      slide = slider.find('.slide');
    setTimeout(function () {
      slide.eq(0).addClass('is-ani');
    }, 100),
      slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        slide.eq(nextSlide).addClass('is-ani'),
          setTimeout(function () {
            slide.eq(currentSlide).removeClass('is-ani');
          }, 1e3);
      }),
      slider.slick({
        autoplay: !0,
        autoplaySpeed: 5500,
        speed: 1500,
        fade: !0,
        pauseOnFocus: !1,
        pauseOnHover: !1,
        pauseOnDotsHover: !1,
        swipe: !1,
        arrows: !1,
      });
  });
});
$(function () {
  var link = $('.comparison-modalLink');
  var modal = $('.wsc-map-modal');
  var modalOverlay = $('.modal-overlay');

  if (link[0]) {
    var runOpen = function (id) {
      // 一度全てのモーダルを閉じる
      modal.removeClass('is-open');
      var tar = $('[data-modal-id="' + id + '"]');
      tar[0] && tar.addClass('is-open');
      // モーダルを開くと同時に、オーバーレイを表示させる
      modalOverlay.addClass('active');
    };

    link.click(function (event) {
      var targetModal = $(this).attr('data-modal-target');
      runOpen(targetModal);
    });

    // モーダル外の半透明背景をクリックしても閉じるようにする
    modalOverlay.click(function (event) {
      modal.removeClass('is-open');
      modalOverlay.removeClass('active');
    });

    // モーダル内の閉じるボタンをクリックしたときも閉じるようにする
    $('.wsc-map-modalClose a').click(function (event) {
      event.preventDefault();
      modal.removeClass('is-open');
      modalOverlay.removeClass('active');
    });
  }
});
$(function () {
  var link = $('.wsc-pick-moviePlayLink');
  if (link[0]) {
    var movie = $('.wsc-pick-movie'),
      video = $('.wsc-pick-movie video'),
      videoEl = video[0];
    link.click(function (event) {
      movie.addClass('is-play'), videoEl.play();
    }),
      video.on('ended', function () {
        movie.removeClass('is-play');
      });
  }
});
$(function () {
  // フェードイン対象の要素を取得
  var fadeElements = $('.fade');
  fadeElements.each(function (index, element) {
    var targetElement = $(this);

    // スクロール、リサイズ、ページ読み込み時に実行する関数
    $(window).on('load resize scroll', function (event) {
      // ウィンドウのスクロール位置を取得
      var windowTop = $(window).scrollTop(),
        windowHeight = $(window).innerHeight(),
        windowBottom = windowTop + windowHeight,
        // フェードイン対象要素の位置情報を取得
        elementTop = targetElement.offset().top,
        elementHeight = targetElement.innerHeight(),
        elementBottom = elementTop + elementHeight,
        // フェードインを開始する位置を計算（フェードイン要素の高さの0%と85%の位置）
        triggerPointTop = elementTop + (elementHeight * 0) / 100,
        triggerPointScroll = windowTop + windowHeight * 0.85,
        delay = 0,
        // フェードインの遅延時間を取得
        triggerPointDelay = targetElement.attr('data-fade-h');
      triggerPointDelay && (triggerPointTop = elementTop + (elementHeight * triggerPointDelay) / 100);

      // フェードインの位置にスクロールが達しているかチェックし、条件を満たす場合にフェードインを実行
      if (triggerPointTop < triggerPointScroll) {
        // フェードインの遅延時間を取得
        var delayAttr = targetElement.attr('data-fade-delay');
        delayAttr && (delay = delayAttr);

        // フェードインの実行
        setTimeout(function () {
          targetElement.addClass('is-fade');
          next();
        }, delay);
      }
    });

    // フェードインが完了した後の処理を行う関数
    function next() {
      // data-fade-next-target属性で指定された要素を取得
      var nextElementsAttr = targetElement.attr('data-fade-next-target');
      if (nextElementsAttr) {
        var nextElementsArray = nextElementsAttr.split(' ');
        if (nextElementsArray) {
          for (var i = 0; i < nextElementsArray.length; i++) {
            var nextElementID = nextElementsArray[i],
              nextTargetElements = $('[data-fade-next-id="' + nextElementID + '"]');
            if (nextTargetElements[0]) {
              // フェードイン後に実行する要素があれば、それに対してもフェードインを実行
              var nextDelayAttr = targetElement.attr('data-fade-next-delay'),
                delayValue = 0;
              nextDelayAttr && (delayValue = parseInt(nextDelayAttr));
              var nextStepAttr = targetElement.attr('data-fade-next-step'),
                stepValue = 0;
              nextDelayAttr && (stepValue = delayValue);
              nextStepAttr && (stepValue = parseInt(nextStepAttr));
              nextTargetElements.each(function (index2, element2) {
                var targetElement2 = $(this),
                  step2 = stepValue * index2 + delayValue;
                setTimeout(function () {
                  targetElement2.addClass('is-fade-next');
                  targetElement2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});
$(function () {
  var pagetop = $('#page_top');
  pagetop.hide(),
    $(window).scroll(function () {
      $(this).scrollTop() > 100 ? pagetop.fadeIn() : pagetop.fadeOut();
    }),
    pagetop.click(function () {
      return $('body, html').animate({ scrollTop: 0 }, 500), !1;
    });
});
//# sourceMappingURL=/s/files/1/0572/0467/0620/t/17/assets/bedlp-common.js.map?v=5645076906291986928
